<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useShipStore } from '@/stores/ship'
import ShipTableRow from '@/components/ship/ShipTableRow.vue'
import ShipTableHeader from '@/components/ship/ShipTableHeader.vue'
import { ShipTable } from '@haskoning/vue-component-library'
import type { ShipType } from '@/stores/type/ship.type'

const shipStore = useShipStore()

const { items: ships, fetchLoading: shipLoading } = storeToRefs(shipStore)

const headers = [
  { title: '' },
  { title: 'Name' },
  { title: 'Length overall [m]' },
  { title: 'Breadth/beam' },
  { title: 'Main propulsion power' },
  { title: 'Rudder' },
  { title: 'Main propeller' },
  { title: 'Transverse thruster power' },
  { title: 'Transverse thruster' },
  { title: 'Edit' },
  { title: '' }
]
</script>

<template>
  <div>
    <ShipTable :items="ships" :loading="shipLoading" :headers="headers">
      <template v-slot:table-header>
        <ShipTableHeader :show-edit="true" />
      </template>
      <template v-slot:table-row="{ item }">
        <ShipTableRow :item="item as ShipType"></ShipTableRow>
      </template>
    </ShipTable>
  </div>
</template>
